export const closingChecklistPtBr = {
  page: {
    title: 'Checklist de fechamento',
    configure: 'Configurar',
    export: 'Exportar',
    deadline: 'Prazo',
  },
  period: {
    statusOpen: 'Aberto',
    statusClosed: 'Fechado',
    statusLocked: 'Bloqueado',
  },
  progress: {
    label: 'Progresso geral',
    ofItemsCompleted: 'de {{total}} itens concluídos',
    completed: 'Concluídos',
    pending: 'Pendentes',
    blocked: 'Bloqueados',
  },
  aiInsight: {
    resolveAutomatically: 'Resolver automaticamente',
    viewDetails: 'Ver detalhes',
  },
  categories: {
    accountsPayable: 'Contas a Pagar',
    accountsReceivable: 'Contas a Receber',
    bankReconciliation: 'Conciliação Bancária',
    taxObligations: 'Obrigações Fiscais',
    accountingGl: 'Contabilidade & GL',
    other: 'Outros',
  },
  transitionDiagnostics: {
    label: '{{tax}} · código {{catalog}} · movimento de {{date}}',
    unknownTax: 'Tributo',
    noCatalog: 'sem código de receita',
    unknownDate: 'data não informada',
    classifySource:
      'Classifique a operação de origem e registre a evidência para liberar a apuração da transição.',
    resolveErrors: 'Revise a operação de origem antes de tentar novamente.',
    actions: {
      AR_INVOICE: 'Abrir fatura',
      AR_DEBIT_NOTE: 'Abrir nota de débito',
      openSource: 'Abrir origem',
    },
  },
  fixedAssetCreditDiagnostics: {
    label: '{{tax}} · crédito fiscal do imobilizado',
    pendingCount: '{{count}} divergência',
    pendingCount_other: '{{count}} divergências',
    reconciled: 'Conciliado',
    amounts: '{{issue}} Esperado: {{expected}} · registrado: {{actual}}.',
    notRecorded: 'não registrado',
    openAsset: 'Abrir ativo',
    issues: {
      default:
        'Os saldos fiscal e contábil não conciliam. Revise as parcelas, perdas e lançamentos do ativo.',
      SOURCE_JOURNAL_INVALID:
        'O lançamento da origem está ausente ou não corresponde ao crédito fiscal.',
      AVAILABLE_OWNER_BALANCE_INVALID:
        'O saldo disponível não corresponde às parcelas fiscais que o compõem.',
      DEFERRED_OWNER_BALANCE_INVALID:
        'O saldo a apropriar não corresponde às parcelas fiscais que o compõem.',
      COMMON_USE_BOOK_REVISION_HISTORY_INVALID:
        'O histórico das revisões de vida útil está incompleto ou possui revisões concorrentes. Confira as revisões vinculadas ao ativo.',
      COMMON_USE_BOOK_REVISION_OWNER_INVALID:
        'A revisão de vida útil não corresponde ao ajuste de rateio vigente. Confira a sequência das revisões e dos ajustes de custo.',
      COMMON_USE_BOOK_REVISION_SCOPE_INVALID:
        'Os livros ou parâmetros atuais divergem da revisão registrada. Confira a vida útil, o residual e a base de cada livro do ativo.',
      COMMON_USE_BOOK_REVISION_SCHEDULE_LINEAGE_INVALID:
        'As parcelas atuais não conciliam com as substituições registradas nas revisões. Confira as parcelas preservadas, substituídas e canceladas do ativo.',
      COMMON_USE_OWNER_HISTORY_INVALID:
        'O histórico de ajustes do custo por rateio está incompleto ou possui correções concorrentes. Revise os ajustes vinculados ao ativo.',
      COMMON_USE_OWNER_DISPOSAL_LINEAGE_INVALID:
        'A baixa não concilia com as parcelas de depreciação canceladas. Revise a baixa e o histórico das parcelas do ativo.',
      COMMON_USE_OWNER_SCHEDULE_LINEAGE_INVALID:
        'As parcelas substituídas pelo ajuste de rateio não conciliam com o histórico atual. Revise os ajustes e as parcelas do ativo.',
      COMMON_USE_OWNER_SCHEDULE_DIVERGENT:
        'A base de depreciação ou o total das parcelas diverge do último ajuste de rateio aprovado.',
      COMMON_USE_OWNER_COST_DIVERGENT:
        'O custo do ativo diverge do último ajuste de rateio aprovado. Revise o custo e os lançamentos vinculados.',
      COMMON_USE_OWNER_BOOK_SCOPE_INVALID:
        'Os livros do ativo não correspondem aos livros registrados no ajuste de rateio. Revise a configuração e o histórico do ativo.',
      COMMON_USE_OWNER_PLAN_VERSION_INVALID:
        'O tipo do ajuste de rateio não corresponde à variação de custo registrada. Encaminhe o histórico do ativo para revisão.',
      FA_PIS_COFINS_RECOVERABILITY_LOSS_BALANCE_INVALID:
        'O valor recuperável e a perda reconhecida não conciliam com o potencial fiscal aberto.',
      EVENT_ALLOCATION_MISMATCH:
        'O valor do evento fiscal não corresponde à sua alocação por parcela.',
      EVENT_IDENTITY_OR_TYPE_INVALID:
        'A origem ou o tipo do evento fiscal não corresponde ao fato registrado.',
      INVALID_SUBLEDGER_ONLY_EVENT:
        'Uma transferência apenas entre saldos fiscais possui evidência contábil incompatível.',
      JOURNAL_MISSING_OR_NOT_POSTED:
        'O lançamento contábil esperado está ausente ou ainda não foi contabilizado.',
      JOURNAL_SCOPE_MISMATCH:
        'O lançamento contábil pertence a outra entidade, livro ou competência.',
      JOURNAL_EVENT_AMOUNT_MISMATCH:
        'O total do lançamento contábil não corresponde ao evento fiscal.',
      JOURNAL_LINE_MISSING_OR_DIVERGENT:
        'Uma linha contábil esperada está ausente ou possui valor divergente.',
      JOURNAL_LINE_CURRENCY_BASIS_INVALID:
        'A base de moeda funcional da linha contábil está incompleta ou inconsistente.',
    },
  },
  fixedAssetDepreciation: {
    pendingDescription:
      '{{count}} parcela de depreciação contábil ainda não foi lançada neste livro e competência.',
    pendingDescription_other:
      '{{count}} parcelas de depreciação contábil ainda não foram lançadas neste livro e competência.',
    pendingCount: '{{count}} parcela pendente',
    pendingCount_other: '{{count}} parcelas pendentes',
    schedule: 'Valor: {{amount}} · competência: {{date}}',
    openAsset: 'Abrir ativo',
  },
  footer: {
    lastUpdated: 'Última atualização: {{date}}',
    updateChecklist: 'Atualizar checklist',
    closePeriod: 'Fechar período',
    closeDisabled: {
      selectPeriod: 'Selecione entidade, livro e período para fechar.',
      loading: 'Aguarde o carregamento do checklist.',
      periodsError: 'Atualize os períodos antes de fechar.',
      tasksError: 'Atualize o checklist antes de fechar o período.',
      scopeNamesLoading: 'Aguarde o carregamento dos nomes da entidade e do livro.',
      blocked: '{{count}} pendência bloqueia o fechamento.',
      blocked_other: '{{count}} pendências bloqueiam o fechamento.',
      notOpen: 'Somente períodos abertos podem ser fechados.',
    },
  },
  closeDialog: {
    title: 'Fechar período {{period}}?',
    description:
      'Entidade {{entity}} · Livro {{book}}. Este período e os períodos anteriores ainda abertos deste livro serão fechados. O próximo período será aberto para os novos lançamentos.',
    confirm: 'Fechar período',
    retry: 'Tentar fechar novamente',
    success: 'Período {{period}} fechado.',
    blockedError:
      'O período ainda tem pendências. Atualizamos o checklist para você revisar os bloqueios antes de tentar novamente.',
    readinessChanged:
      'O checklist ou o período mudou desde que você abriu esta confirmação. Atualize os dados antes de tentar novamente.',
    genericError:
      'Não conseguimos fechar o período. Atualizamos o checklist; revise as pendências e tente novamente.',
  },
  pendingReviews: 'Revisões contábeis pendentes',
  reviewQueue: {
    loading: 'Carregando revisões…',
    error: 'Não foi possível carregar as revisões.',
    empty: { reviews: 'Nenhuma revisão pendente.' },
    taxLiability: 'Passivo tributário',
    accountingReview: 'Revisão contábil',
    competencyEstimated: '(competência estimada)',
    metrics: {
      title: 'Uso de revisão contábil nas guias aprovadas',
      loading: 'Carregando indicadores de revisão contábil…',
      error: 'Não foi possível carregar os indicadores de revisão contábil.',
      approvedBills: 'Guias aprovadas',
      fallbackBills: 'Com revisão pendente',
      rate: 'Taxa de revisão',
      reasons: 'Motivos registrados',
    },
    table: {
      vendor: 'Fornecedor',
      document: 'Documento',
      requestType: 'Tipo',
      competency: 'Competência',
      reason: 'Motivo',
      amount: 'Valor',
      actions: 'Ações',
    },
    actions: { openBill: 'Abrir conta', openReview: 'Abrir revisão', retry: 'Tentar novamente' },
  },
  internalTransfersPendingGl: {
    title: 'Transferências internas pendentes de lançamento contábil',
    description:
      'Pares BANK→BANK sem postagem na GL (ou com falha) e transferências aguardando o par — resolver antes do fechamento',
    badgeLabel: '{{withoutGl}} sem GL · {{awaiting}} aguardando par',
    actionLabel: 'Resolver →',
  },
  arInvoiceErrors: {
    title: 'Faturas em status de erro',
    description: 'Revise as faturas de contas a receber com falha antes de concluir o fechamento.',
    doneDescription: 'Nenhuma fatura de contas a receber em erro.',
    badgeLabel: '{{count}} fatura(s)',
    actionLabel: 'Revisar faturas →',
  },
  aiPostingReview: {
    title: 'Postagens contábeis a revisar',
    vendor: 'Fornecedor',
    amount: 'Valor',
    empty: 'Nenhuma postagem com esses filtros.',
    emptyTitle: 'Nenhuma postagem contábil',
    reviewedToast: 'Postagem marcada como revisada.',
    staleToast:
      'O lançamento mudou desde que a lista foi carregada. Recarregamos; confira antes de revisar.',
    reviewFilter: 'Revisão',
    statusFilter: 'Geração',
    bill: 'Conta a pagar',
    review: { UNREVIEWED: 'Aguardando revisão', REVIEWED: 'Revisadas', ALL: 'Todas' },
    status: { POSTED: 'Postados pela IA', FALLBACK: 'Lançamento padrão' },
    competencia: 'Competência',
    reviewed: 'Revisado',
    unreviewed: 'Postado pela IA',
    classificationDivergence: 'Conta fora da classificação',
    pending: 'Pendente',
    pendingFailed: 'Provisão não postada',
    markReviewed: 'Marcar revisado',
    viewEntry: 'Ver lançamento',
    postedAt: 'Postado em',
    fallback: {
      AP_AI_POSTING_TIMEOUT: 'Padrão: IA não respondeu',
      AP_AI_POSTING_LOW_CONFIDENCE: 'Padrão: confiança baixa',
      AP_AI_POSTING_WORKER_FALLBACK: 'Padrão: aprovação automática',
      AP_AI_POSTING_RECLASSIFIED: 'Padrão: reclassificada',
      AP_AI_POSTING_ASSET_OUTSIDE_CLASSIFICATION: 'Padrão: ativo fora da classificação',
      OTHER: 'Padrão: proposta da IA recusada',
    },
  },
  pendingReimbursements: {
    title: 'Reembolsos de clientes pendentes (30+ dias)',
    subtitle:
      'Despesas reembolsáveis envelhecidas aguardando cobrança do cliente — candidatas a baixa por perda.',
    loading: 'Carregando reembolsos pendentes...',
    error: 'Falha ao carregar reembolsos pendentes.',
    pendingCount: 'Pendentes',
    totalAmount: 'Valor total',
    threshold: 'Idade mínima',
    thresholdValue: '{{days}}+ dias',
    tableHint: 'Exibindo {{count}} de {{total}} conta(s)',
    bill: 'Conta',
    customer: 'Cliente',
    amount: 'Valor',
    pendingSince: 'Pendente desde',
    ageDays: '{{count}} dia(s)',
    actions: 'Ações',
    writeOff: 'Baixar como perda',
    writeOffAll: 'Baixar todas como perda',
    writeOffAllTarget: '{{count}} conta(s) elegíveis',
    confirm: {
      title: 'Baixar reembolso como perda',
      description:
        'Confirmar a baixa por perda de {{target}}? Será gerado um lançamento contábil de perda (D: Perdas com Reembolsos de Clientes / C: Valores a Recuperar) e a(s) conta(s) deixará(ão) de ser reembolsável(is) pelo cliente. Esta ação não pode ser desfeita.',
      confirm: 'Baixar como perda',
    },
    toasts: {
      writtenOff: '{{count}} conta(s) baixada(s) como perda',
      writeOffError: 'Erro ao baixar como perda: {{error}}',
    },
  },
  customTasks: {
    page: {
      title: 'Tarefas customizadas',
    },
    filters: {
      title: 'Filtros',
      section: 'Seção',
      allSections: 'Todas as seções',
    },
    sheet: {
      title: 'Tarefas customizadas',
      description:
        'Crie e gerencie modelos de tarefas que serão adicionados a cada período aberto.',
    },
    searchPlaceholder: 'Pesquisar tarefas...',
    newTask: 'Nova tarefa',
    editTask: 'Editar tarefa',
    archiveTask: 'Arquivar tarefa',
    empty: 'Nenhuma tarefa customizada encontrada.',
    unassigned: 'Sem responsável',
    responsibleLabel: 'Responsável: {{name}}',
    dueDay: 'Dia {{day}}',
    dueDateLabel: 'Data limite: {{date}}',
    overdueAlert: 'Em atraso',
    evidenceRequired: 'Exige evidência',
    evidenceNotRequired: 'Sem evidência obrigatória',
    evidenceBadge: '{{count}} evidência(s)',
    selectPeriodHint:
      'Selecione entidade, livro e período para carregar as tarefas de fechamento do período.',
    periodTaskHint: '{{count}} tarefas de fechamento carregadas para {{period}}.',
    loadingPeriodTasks: 'Carregando tarefas de fechamento',
    periodTasksError: 'Não foi possível carregar as tarefas de fechamento deste período.',
    sections: {
      none: 'Sem seção',
      ACCOUNTS_PAYABLE: 'Contas a Pagar',
      BANK_RECONCILIATION: 'Conciliação Bancária',
      TAX_OBLIGATIONS: 'Obrigações Fiscais',
      ACCOUNTING_GL: 'Contabilidade & GL',
      BILLING: 'Billing / Contratos',
    },
    statusFilter: {
      label: 'Status: {{value}}',
      ALL: 'Todos',
      ACTIVE: 'Ativos',
      INACTIVE: 'Inativos',
      DELETED: 'Arquivados',
      DRAFT: 'Rascunhos',
    },
    table: {
      title: 'Título',
      section: 'Seção',
      responsible: 'Responsável',
      dueBy: 'Vence em',
      evidence: 'Evidência',
      actions: 'Ações',
    },
    form: {
      newTitle: 'Nova tarefa customizada',
      editTitle: 'Editar tarefa customizada',
      description: 'Configure os detalhes da tarefa de fechamento.',
      title: 'Título',
      titlePlaceholder: 'Ex: Revisar cutoff de AP',
      descriptionLabel: 'Descrição',
      descriptionPlaceholder: 'Instruções para conclusão da tarefa',
      section: 'Seção',
      sectionPlaceholder: 'Selecione a seção',
      dueDay: 'Vence até o dia do mês',
      dueDayPlaceholder: 'Ex: 15',
      responsible: 'Responsável',
      responsiblePlaceholder: 'Selecione o responsável',
      requireEvidence: 'Exigir evidência para concluir',
      requireEvidenceHint: 'A tarefa só poderá ser marcada como concluída após evidência anexada.',
      attachments: 'Anexos',
      attachmentsHint: 'Arquivos de apoio opcionais para a tarefa.',
      attachmentsSelected: '{{count}} arquivo(s) selecionado(s).',
      cancel: 'Cancelar',
      save: 'Salvar',
      saving: 'Salvando...',
    },
    actions: {
      markDone: 'Concluir',
      reopen: 'Reabrir',
      retry: 'Tentar novamente',
      viewHistory: 'Ver histórico',
    },
    completion: {
      title: 'Concluir tarefa',
      observations: 'Observações',
      observationsPlaceholder: 'Descreva o que foi revisado ou concluído',
      evidenceRequired: 'Evidências obrigatórias',
      evidenceOptional: 'Evidências opcionais',
      evidenceHint: 'Anexe arquivos que comprovem a conclusão da tarefa.',
      evidenceRequiredError: 'Anexe pelo menos uma evidência para concluir esta tarefa.',
      chooseFiles: 'Escolher arquivos',
      noFileChosen: 'Nenhum arquivo escolhido',
      deleteEvidence: 'Remover evidência',
      save: 'Salvar conclusão',
    },
    history: {
      title: 'Histórico da tarefa',
      completedAt: 'Concluída em',
      observations: 'Observações',
      noObservations: 'Nenhuma observação registrada.',
      attachments: 'Evidências',
      noAttachments: 'Nenhuma evidência anexada.',
      openAttachmentError: 'Erro ao abrir evidência: {{error}}',
    },
    archiveConfirm: {
      title: 'Arquivar tarefa customizada',
      description:
        'Tem certeza que deseja arquivar "{{title}}"? Ela não será adicionada a novos períodos abertos.',
      confirm: 'Arquivar',
    },
    backfillConfirm: {
      title: 'Adicionar tarefa a períodos anteriores?',
      description:
        'Existem {{count}} período(s) aberto(s) anteriores ao mês atual. Deseja criar esta tarefa também nesses períodos ou somente a partir de agora?',
      allOpen: 'Adicionar em todos',
      currentAndFuture: 'Somente a partir de agora',
    },
    toasts: {
      created: 'Tarefa criada com sucesso',
      updated: 'Tarefa atualizada com sucesso',
      archived: 'Tarefa arquivada com sucesso',
      createError: 'Erro ao criar tarefa: {{error}}',
      updateError: 'Erro ao atualizar tarefa: {{error}}',
      archiveError: 'Erro ao arquivar tarefa: {{error}}',
      attachmentDeleted: 'Evidência removida',
      attachmentDeleteError: 'Erro ao remover evidência: {{error}}',
      periodTaskUpdated: 'Tarefa do período atualizada',
      periodTaskError: 'Erro ao atualizar tarefa do período: {{error}}',
    },
  },
};

export const closingChecklistEn = {
  page: {
    title: 'Closing checklist',
    configure: 'Configure',
    export: 'Export',
    deadline: 'Deadline',
  },
  period: {
    statusOpen: 'Open',
    statusClosed: 'Closed',
    statusLocked: 'Locked',
  },
  progress: {
    label: 'Overall progress',
    ofItemsCompleted: 'of {{total}} items completed',
    completed: 'Completed',
    pending: 'Pending',
    blocked: 'Blocked',
  },
  aiInsight: {
    resolveAutomatically: 'Resolve automatically',
    viewDetails: 'View details',
  },
  categories: {
    accountsPayable: 'Accounts Payable',
    accountsReceivable: 'Accounts Receivable',
    bankReconciliation: 'Bank Reconciliation',
    taxObligations: 'Tax Obligations',
    accountingGl: 'Accounting & GL',
    other: 'Other',
  },
  transitionDiagnostics: {
    label: '{{tax}} · code {{catalog}} · movement on {{date}}',
    unknownTax: 'Tax',
    noCatalog: 'no revenue code',
    unknownDate: 'date not provided',
    classifySource:
      'Classify the source operation and record the evidence to release the transition assessment.',
    resolveErrors: 'Review the source operation before trying again.',
    actions: {
      AR_INVOICE: 'Open invoice',
      AR_DEBIT_NOTE: 'Open debit note',
      openSource: 'Open source',
    },
  },
  fixedAssetCreditDiagnostics: {
    label: '{{tax}} · fixed-asset tax credit',
    pendingCount: '{{count}} discrepancy',
    pendingCount_other: '{{count}} discrepancies',
    reconciled: 'Reconciled',
    amounts: '{{issue}} Expected: {{expected}} · recorded: {{actual}}.',
    notRecorded: 'not recorded',
    openAsset: 'Open asset',
    issues: {
      default:
        'The tax and accounting balances do not reconcile. Review the asset installments, losses, and journals.',
      SOURCE_JOURNAL_INVALID: 'The source journal is missing or does not match the tax credit.',
      AVAILABLE_OWNER_BALANCE_INVALID:
        'The available balance does not match its underlying tax installments.',
      DEFERRED_OWNER_BALANCE_INVALID:
        'The deferred balance does not match its underlying tax installments.',
      COMMON_USE_BOOK_REVISION_HISTORY_INVALID:
        'The useful-life revision history is incomplete or contains conflicting revisions. Review the revisions linked to the asset.',
      COMMON_USE_BOOK_REVISION_OWNER_INVALID:
        'The useful-life revision does not match the current allocation adjustment. Review the sequence of revisions and cost adjustments.',
      COMMON_USE_BOOK_REVISION_SCOPE_INVALID:
        'The current books or parameters differ from the recorded revision. Review useful life, residual and basis for each asset book.',
      COMMON_USE_BOOK_REVISION_SCHEDULE_LINEAGE_INVALID:
        'The current installments do not reconcile with the replacements recorded in revisions. Review the preserved, replaced and cancelled asset installments.',
      COMMON_USE_OWNER_HISTORY_INVALID:
        'The cost-allocation adjustment history is incomplete or contains conflicting corrections. Review the adjustments linked to the asset.',
      COMMON_USE_OWNER_DISPOSAL_LINEAGE_INVALID:
        'The disposal does not reconcile with the cancelled depreciation installments. Review the disposal and asset schedule history.',
      COMMON_USE_OWNER_SCHEDULE_LINEAGE_INVALID:
        'The installments replaced by the allocation adjustment do not reconcile with current history. Review the asset adjustments and schedules.',
      COMMON_USE_OWNER_SCHEDULE_DIVERGENT:
        'The depreciation basis or schedule total differs from the latest approved allocation adjustment.',
      COMMON_USE_OWNER_COST_DIVERGENT:
        'The asset cost differs from the latest approved allocation adjustment. Review the cost and linked journals.',
      COMMON_USE_OWNER_BOOK_SCOPE_INVALID:
        'The asset books do not match the books recorded in the allocation adjustment. Review the asset configuration and history.',
      COMMON_USE_OWNER_PLAN_VERSION_INVALID:
        'The allocation adjustment type does not match the recorded cost change. Send the asset history for review.',
      FA_PIS_COFINS_RECOVERABILITY_LOSS_BALANCE_INVALID:
        'The recoverable amount and recognized loss do not reconcile with the open tax potential.',
      EVENT_ALLOCATION_MISMATCH: 'The tax event amount does not match its installment allocation.',
      EVENT_IDENTITY_OR_TYPE_INVALID:
        'The tax event source or type does not match the recorded fact.',
      INVALID_SUBLEDGER_ONLY_EVENT:
        'A transfer only between tax balances has incompatible accounting evidence.',
      JOURNAL_MISSING_OR_NOT_POSTED:
        'The expected accounting journal is missing or has not been posted.',
      JOURNAL_SCOPE_MISMATCH: 'The accounting journal belongs to another entity, book, or period.',
      JOURNAL_EVENT_AMOUNT_MISMATCH: 'The accounting journal total does not match the tax event.',
      JOURNAL_LINE_MISSING_OR_DIVERGENT:
        'An expected accounting line is missing or has a different amount.',
      JOURNAL_LINE_CURRENCY_BASIS_INVALID:
        'The accounting line functional-currency basis is incomplete or inconsistent.',
    },
  },
  fixedAssetDepreciation: {
    pendingDescription:
      '{{count}} accounting depreciation installment has not been posted in this book and period.',
    pendingDescription_other:
      '{{count}} accounting depreciation installments have not been posted in this book and period.',
    pendingCount: '{{count}} pending installment',
    pendingCount_other: '{{count}} pending installments',
    schedule: 'Amount: {{amount}} · period: {{date}}',
    openAsset: 'Open asset',
  },
  footer: {
    lastUpdated: 'Last updated: {{date}}',
    updateChecklist: 'Update checklist',
    closePeriod: 'Close period',
    closeDisabled: {
      selectPeriod: 'Select an entity, book, and period to close.',
      loading: 'Wait for the checklist to load.',
      periodsError: 'Update the periods before closing.',
      tasksError: 'Update the checklist before closing the period.',
      scopeNamesLoading: 'Wait for the entity and book names to load.',
      blocked: '{{count}} open item blocks closing.',
      blocked_other: '{{count}} open items block closing.',
      notOpen: 'Only open periods can be closed.',
    },
  },
  closeDialog: {
    title: 'Close period {{period}}?',
    description:
      'Entity {{entity}} · Book {{book}}. This period and any earlier open periods in this book will be closed. The next period will be opened for new entries.',
    confirm: 'Close period',
    retry: 'Try closing again',
    success: 'Period {{period}} closed.',
    blockedError:
      'The period still has open items. We updated the checklist so you can review the blockers before trying again.',
    readinessChanged:
      'The checklist or period changed after you opened this confirmation. Update the data before trying again.',
    genericError:
      'We could not close the period. We updated the checklist; review the open items and try again.',
  },
  pendingReviews: 'Pending accounting reviews',
  reviewQueue: {
    loading: 'Loading reviews…',
    error: 'Could not load reviews.',
    empty: { reviews: 'No pending reviews.' },
    taxLiability: 'Tax liability',
    accountingReview: 'Accounting review',
    competencyEstimated: '(estimated competency)',
    metrics: {
      title: 'Accounting review use for approved tax guides',
      loading: 'Loading accounting review metrics…',
      error: 'Could not load the accounting review metrics.',
      approvedBills: 'Approved tax guides',
      fallbackBills: 'Pending review',
      rate: 'Review rate',
      reasons: 'Recorded reasons',
    },
    table: {
      vendor: 'Vendor',
      document: 'Document',
      requestType: 'Type',
      competency: 'Competency',
      reason: 'Reason',
      amount: 'Amount',
      actions: 'Actions',
    },
    actions: { openBill: 'Open bill', openReview: 'Open review', retry: 'Try again' },
  },
  internalTransfersPendingGl: {
    title: 'Internal transfers pending GL posting',
    description:
      'BANK→BANK pairs without GL posting (or with failure) and transfers awaiting their pair — resolve before period close',
    badgeLabel: '{{withoutGl}} without GL · {{awaiting}} awaiting pair',
    actionLabel: 'Resolve →',
  },
  arInvoiceErrors: {
    title: 'Invoices in error status',
    description: 'Review accounts receivable invoices with failures before closing the period.',
    doneDescription: 'No accounts receivable invoices in error.',
    badgeLabel: '{{count}} invoice(s)',
    actionLabel: 'Review invoices →',
  },
  aiPostingReview: {
    title: 'Accounting postings to review',
    vendor: 'Vendor',
    amount: 'Amount',
    empty: 'No postings match these filters.',
    emptyTitle: 'No accounting postings',
    reviewedToast: 'Posting marked as reviewed.',
    staleToast:
      'The entry changed since the list loaded. We reloaded it; check it before reviewing.',
    reviewFilter: 'Review',
    statusFilter: 'Generated by',
    bill: 'Bill',
    review: { UNREVIEWED: 'Awaiting review', REVIEWED: 'Reviewed', ALL: 'All' },
    status: { POSTED: 'Posted by AI', FALLBACK: 'Standard entry' },
    competencia: 'Competency',
    reviewed: 'Reviewed',
    unreviewed: 'Posted by AI',
    classificationDivergence: 'Account outside the classification',
    pending: 'Pending',
    pendingFailed: 'Provision not posted',
    markReviewed: 'Mark reviewed',
    viewEntry: 'View entry',
    postedAt: 'Posted at',
    fallback: {
      AP_AI_POSTING_TIMEOUT: "Standard: AI didn't respond",
      AP_AI_POSTING_LOW_CONFIDENCE: 'Standard: low confidence',
      AP_AI_POSTING_WORKER_FALLBACK: 'Standard: automatic approval',
      AP_AI_POSTING_RECLASSIFIED: 'Standard: reclassified',
      AP_AI_POSTING_ASSET_OUTSIDE_CLASSIFICATION: 'Standard: asset outside the classification',
      OTHER: 'Standard: AI proposal refused',
    },
  },
  pendingReimbursements: {
    title: 'Pending client reimbursements (30+ days)',
    subtitle: 'Aged reimbursable expenses awaiting client billing — write-off candidates.',
    loading: 'Loading pending reimbursements...',
    error: 'Failed to load pending reimbursements.',
    pendingCount: 'Pending',
    totalAmount: 'Total amount',
    threshold: 'Minimum age',
    thresholdValue: '{{days}}+ days',
    tableHint: 'Showing {{count}} of {{total}} bill(s)',
    bill: 'Bill',
    customer: 'Customer',
    amount: 'Amount',
    pendingSince: 'Pending since',
    ageDays: '{{count}} day(s)',
    actions: 'Actions',
    writeOff: 'Write off as loss',
    writeOffAll: 'Write off all as loss',
    writeOffAllTarget: '{{count}} eligible bill(s)',
    confirm: {
      title: 'Write off reimbursement as loss',
      description:
        'Confirm the write-off of {{target}}? A loss journal entry will be posted (DR Client Reimbursement Losses / CR Client Recoverables) and the bill(s) will no longer be reimbursable by the client. This action cannot be undone.',
      confirm: 'Write off as loss',
    },
    toasts: {
      writtenOff: '{{count}} bill(s) written off as loss',
      writeOffError: 'Error writing off as loss: {{error}}',
    },
  },
  customTasks: {
    page: {
      title: 'Custom tasks',
    },
    filters: {
      title: 'Filters',
      section: 'Section',
      allSections: 'All sections',
    },
    sheet: {
      title: 'Custom tasks',
      description: 'Create and manage task templates added to every open period.',
    },
    searchPlaceholder: 'Search tasks...',
    newTask: 'New task',
    editTask: 'Edit task',
    archiveTask: 'Archive task',
    empty: 'No custom tasks found.',
    unassigned: 'Unassigned',
    responsibleLabel: 'Responsible: {{name}}',
    dueDay: 'Day {{day}}',
    dueDateLabel: 'Due date: {{date}}',
    overdueAlert: 'Overdue',
    evidenceRequired: 'Requires evidence',
    evidenceNotRequired: 'No evidence required',
    evidenceBadge: '{{count}} evidence file(s)',
    selectPeriodHint: 'Select entity, book, and period to load its closing tasks.',
    periodTaskHint: '{{count}} closing tasks loaded for {{period}}.',
    loadingPeriodTasks: 'Loading closing tasks',
    periodTasksError: 'Could not load the closing tasks for this period.',
    sections: {
      none: 'No section',
      ACCOUNTS_PAYABLE: 'Accounts Payable',
      BANK_RECONCILIATION: 'Bank Reconciliation',
      TAX_OBLIGATIONS: 'Tax Obligations',
      ACCOUNTING_GL: 'Accounting & GL',
      BILLING: 'Billing / Contracts',
    },
    statusFilter: {
      label: 'Status: {{value}}',
      ALL: 'All',
      ACTIVE: 'Active',
      INACTIVE: 'Inactive',
      DELETED: 'Archived',
      DRAFT: 'Draft',
    },
    table: {
      title: 'Title',
      section: 'Section',
      responsible: 'Responsible',
      dueBy: 'Due by',
      evidence: 'Evidence',
      actions: 'Actions',
    },
    form: {
      newTitle: 'New custom task',
      editTitle: 'Edit custom task',
      description: 'Configure closing task details.',
      title: 'Title',
      titlePlaceholder: 'Example: Review AP cutoff',
      descriptionLabel: 'Description',
      descriptionPlaceholder: 'Instructions to complete the task',
      section: 'Section',
      sectionPlaceholder: 'Select the section',
      dueDay: 'Due by day of month',
      dueDayPlaceholder: 'Example: 15',
      responsible: 'Responsible',
      responsiblePlaceholder: 'Select the responsible user',
      requireEvidence: 'Require evidence to complete',
      requireEvidenceHint: 'The task can only be marked done after evidence is attached.',
      attachments: 'Attachments',
      attachmentsHint: 'Optional supporting files for the task.',
      attachmentsSelected: '{{count}} file(s) selected.',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
    },
    actions: {
      markDone: 'Mark done',
      reopen: 'Reopen',
      retry: 'Try again',
      viewHistory: 'View history',
    },
    completion: {
      title: 'Complete task',
      observations: 'Observations',
      observationsPlaceholder: 'Describe what was reviewed or completed',
      evidenceRequired: 'Required evidence',
      evidenceOptional: 'Optional evidence',
      evidenceHint: 'Attach files that support task completion.',
      evidenceRequiredError: 'Attach at least one evidence file to complete this task.',
      chooseFiles: 'Choose files',
      noFileChosen: 'No file chosen',
      deleteEvidence: 'Remove evidence',
      save: 'Save completion',
    },
    history: {
      title: 'Task history',
      completedAt: 'Completed at',
      observations: 'Observations',
      noObservations: 'No observations recorded.',
      attachments: 'Evidence',
      noAttachments: 'No evidence attached.',
      openAttachmentError: 'Error opening evidence: {{error}}',
    },
    archiveConfirm: {
      title: 'Archive custom task',
      description:
        'Are you sure you want to archive "{{title}}"? It will not be added to new open periods.',
      confirm: 'Archive',
    },
    backfillConfirm: {
      title: 'Add task to previous periods?',
      description:
        'There are {{count}} open period(s) before the current month. Do you want to create this task there too, or only from now on?',
      allOpen: 'Add to all',
      currentAndFuture: 'Only from now on',
    },
    toasts: {
      created: 'Task created successfully',
      updated: 'Task updated successfully',
      archived: 'Task archived successfully',
      createError: 'Error creating task: {{error}}',
      updateError: 'Error updating task: {{error}}',
      archiveError: 'Error archiving task: {{error}}',
      attachmentDeleted: 'Evidence removed',
      attachmentDeleteError: 'Error removing evidence: {{error}}',
      periodTaskUpdated: 'Period task updated',
      periodTaskError: 'Error updating period task: {{error}}',
    },
  },
};
